import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, AlertCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import useDocumentMetadata from '../hooks/useDocumentMetadata';

export default function NotFound() {
  const { t, lang } = useLanguage();

  const seoTitle = lang === 'da'
    ? '404 - Siden blev ikke fundet | Nordisk Psykiatri'
    : '404 - Sidan hittades inte | Nordisk Psykiatri';

  const seoDesc = lang === 'da'
    ? 'Beklager, men den side du leder efter findes ikke eller er blevet flyttet.'
    : 'Tyvärr finns inte sidan du letar efter eller så har den flyttats.';

  useDocumentMetadata(seoTitle, seoDesc, { noIndex: true, lang });

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-sand-light px-6 py-24 text-center">
      <div className="p-4 rounded-full bg-dusty-light text-petrol-medium mb-6">
        <AlertCircle className="h-12 w-12" />
      </div>
      <h1 className="font-display text-4xl font-light tracking-tight text-petrol-dark sm:text-5xl">
        {t('not_found.title')}
      </h1>
      <p className="mt-6 text-base leading-7 text-text-dark/80 max-w-md">
        {t('not_found.desc')}
      </p>
      <div className="mt-10">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full bg-petrol-medium px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-petrol-dark transition-colors gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('not_found.btn')}
        </Link>
      </div>
    </div>
  );
}
